module.exports = __webpack_public_path__ + "img/enterprise-security-solutionsimg-3.194356cb.png";